
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop, Watch } from "vue-property-decorator";
    import Utils from "@/utilities/Utils";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";

    import "leaflet/dist/leaflet.css";
    import { LatLng, LatLngBounds } from "leaflet";
    import { LMap, LTileLayer, LMarker, LIcon, LFeatureGroup } from "vue2-leaflet";

    import { MapOptions } from "@/model/pagePartOptions/MapOptions";

    @Component({components: {
            PrimaryButton,
            LMap,
            LTileLayer,
            LMarker,
            LIcon,
            LFeatureGroup
        }})
    export default class MapPartLeaflet extends Vue {

        mounted(): void {
            if (+this.options.latitude !== 0 || +this.options.longitude !== 0) {
                this.center.lat = this.options.latitude;
                this.center.lng = this.options.longitude;
                this.zoom = this.options.initialZoom < 1 ? 12 : this.options.initialZoom;
            }
        }

        @Prop({ default: new MapOptions() })
        options!: MapOptions;

        @Prop({ default: false })
        isAdminView!: boolean;

        // default showing most of British Isles
        zoom: number = 6;
        center = new LatLng(54, -4);

        @Watch("options", { immediate: false, deep: true })
        onOptionsChanged(): void {
            //const map = this.$refs.locationMap as LMap;

            this.center.lat = this.options.latitude;
            this.center.lng = this.options.longitude;
            this.zoom = this.options.initialZoom < 1 ? 12 : this.options.initialZoom;
        }

        // couple of other (static) map settings
        readonly url: string = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        readonly attribution: string = "&copy; <a href='http://osm.org/copyright'>OpenStreetMap</a> contributors";

        get markerLatLng(): LatLng { return new LatLng(this.options?.latitude ?? 0, this.options?.longitude ?? 0); }

        get latitudeText(): string { return String(Utils.roundDegrees(this.options?.latitude ?? 0)); }

        get longitudeText(): string { return String(Utils.roundDegrees(this.options?.longitude ?? 0)); }

    }
